import { ComponentCommunicationService } from 'src/app/component-communication.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnumConverterService } from 'src/app/services/EnumConverterService';
import { OptionsEnum } from 'src/app/model/enums/OptionsEnum';

@Component({
  selector: 'app-application-other-insurances',
  templateUrl: './application-other-insurances.component.html',
  styleUrls: ['./application-other-insurances.component.css'],
})
export class ApplicationOtherInsurancesComponent implements OnInit {
  @Input()
  otherInsurancesFormGroup: FormGroup;

  yesNoList = this.enumConverterService.toBaseList('OptionsEnum', OptionsEnum);
  OptionsEnum = OptionsEnum;
  dateMask: string;

  constructor(
    private enumConverterService: EnumConverterService,
    private componentCommunication: ComponentCommunicationService
  ) {}

  ngOnInit(): void {
    this.otherInsurancesFormGroup
      .get('tafInsurer')
      .valueChanges.subscribe((tafInsurer) => {
        if (tafInsurer === OptionsEnum.Yes) {
          this.otherInsurancesFormGroup.get('nameInsurer').patchValue('TAF');
          this.otherInsurancesFormGroup.get('nameInsurer').disable();
        } else {
          this.otherInsurancesFormGroup.get('nameInsurer').patchValue('');
          this.otherInsurancesFormGroup.get('nameInsurer').enable();
        }
      });
  }

  get dateMaskFormat(): string {
    return this.componentCommunication.getDateFormat();
  }

  get willCancelPolicy(): boolean {
    return this.otherInsurancesFormGroup.get('willCancelPolicy').value === OptionsEnum.Yes;
  }
}
